"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboboxOptionMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Highlight = require("../../components/Highlight/Highlight.styles");
var ComboboxOptionMixin = function ComboboxOptionMixin(props) {
  return (0, _styledToken.default)({
    fontWeight: 'ComboboxOption.Highlight.fontWeight',
    backgroundColor: 'ComboboxOption.Highlight.backgroundColor'
  }, function (_ref) {
    var _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? 'bold' : _ref$fontWeight,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    return (0, _styledComponents.css)(["", "{font-weight:", ";background-color:", ";}"], _Highlight.StyledHighlight, fontWeight, backgroundColor);
  })(props);
};
exports.ComboboxOptionMixin = ComboboxOptionMixin;